import CkEditorsContainer from "../../Componant/Editors/CkEditors";

const CkEditors = () => {
  return (
    <div className="page-body">
      <CkEditorsContainer />
    </div>
  );
};

export default CkEditors;
